import { formatDistanceToNow, isValid } from 'date-fns';
import { ca, enUS, es } from 'date-fns/locale';

const LOCALES: Record<string, Locale> = { es, ca, en: enUS };

export class RegistrationDateMap {
  static toRelativeText(registrationDate: Date | string | null | undefined, language: string): string | undefined {
    if (!registrationDate) return undefined;

    const date = new Date(registrationDate);
    if (!isValid(date)) return undefined;

    const relativeText = formatDistanceToNow(date, { addSuffix: true, locale: LOCALES[language] ?? es });

    return relativeText.charAt(0).toUpperCase() + relativeText.slice(1);
  }
}
